import { Modal, TextInput, Textarea, Button } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useRef, useState } from "react";
import { IconCircleCheck } from "@tabler/icons-react";
import { api } from "../services/master.service";
import { showErrorToast } from "../utilities/Toast";

export default function AreaFeedbackModal({ opened, close }) {

  const areaRef = useRef(null);
  const phoneRef = useRef(null);
  const descRef = useRef(null);

  const [success, setSuccess] = useState(false);

  const form = useForm({
    initialValues: {
      name: "",
      area_name: "",
      phone: "",
      description: ""
    },

    validate: {
      name: (v) => (v ? null : "Name required"),
      area_name: (v) => (v ? null : "Street name required"),
      phone: (v) => (v ? null : "Phone required"),
      description: (v) => (v ? null : "Description required")
    }
  });

  const submitFeedback = async () => {

    const payload = {
      name: form.values.name,
      area_name: form.values.area_name,
      phone: form.values.phone,
      description: form.values.description
    };

    const res = await api.create_area_feedback(payload);

    if (res.success) {
      setSuccess(true);
      form.reset();
    } else {

      showErrorToast({
        title: "Error",
        message: res.message
      });

    }
  };

  return (

    <Modal
      opened={opened}
      onClose={() => {
        setSuccess(false);
        close();
      }}
      title="Street Feedback"
      centered
    >

      {success ? (

        <div style={{ textAlign: "center", padding: "30px" }}>

          <IconCircleCheck size={70} color="green" />

          <h3 style={{ marginTop: "15px" }}>
            Street Feedback Added Successfully
          </h3>

          <p>
            We will get back to you soon, Thank you.
          </p>

          <Button
            mt="md"
            onClick={() => {
              setSuccess(false);
              close();
            }}
          >
            Close
          </Button>

        </div>

      ) : (

        <form onSubmit={form.onSubmit(submitFeedback)}>

          <TextInput
            label="Name"
            placeholder="Enter name"
            {...form.getInputProps("name")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                areaRef.current.focus();
              }
            }}
          />

          <TextInput
            label="Street Name"
            mt="md"
            placeholder="Enter street name"
            ref={areaRef}
            {...form.getInputProps("area_name")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                phoneRef.current.focus();
              }
            }}
          />

          <TextInput
            label="Phone Number"
            mt="md"
            placeholder="Enter phone number"
            ref={phoneRef}
            maxLength={10}
            {...form.getInputProps("phone")}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                descRef.current.focus();
              }
            }}
          />

          <Textarea
            label="Description"
            mt="md"
            minRows={3}
            placeholder="Enter description"
            ref={descRef}
            {...form.getInputProps("description")}
          />

          <Button fullWidth mt="lg" type="submit">
            Submit
          </Button>

        </form>

      )}

    </Modal>

  );
}